import styled from 'styled-components';

export const L2CategoryContainer = styled.div`
  background-color: #f4f4f4;
  display: flex;
  column-gap: 18px;
  padding: 12px;
  overflow: auto hidden;
  border-bottom: 1px solid hsl(0deg 0% 0% / 10%);
  .selected {
    font-weight: 600;
    color: hsl(0deg, 0%, 0%, 80%);
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 4px;
      background-color: #6e6e6e;
      left: 0;
      top: 24px;
      border-radius: 4px 4px 0 0;
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 720px) {
    display: none;
  }
`;
export const L2CategoryInner = styled.a`
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  color: hsl(0deg 0% 0% / 40%);
  text-transform: capitalize;
  flex-shrink: 0;
  display: inline-block;

  @media (max-width: 720px) {
    cursor: default;
  }
`;

export const CategoryHyperLinkSection = styled.div`
  margin: 10px 0;
`;

export const CategoryHyperlink = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 10px 8px;
  color: #0053a7;
  font-weight: 500;
  font-size: clamp(13px, 2vw, 16px);
  letter-spacing: 0.3px;

  a {
    border-right: 1px solid hsl(0deg, 0%, 0%, 20%);
    padding: 7px 0;
    display: inline-block;

    &:hover {
      text-decoration: underline;
    }

    @media (min-width: 768px) {
      border-right: none;
    }

    &:nth-child(even) {
      border-right: none;
      padding-left: 9px;
    }

    &:nth-child(odd) {
      padding-right: 9px;
    }
  }
`;

export const MoreCategoryL2Title = styled.h3`
  font-weight: 500;
  font-size: clamp(16px, 2vw, 18px);
  padding: 10px 8px 6px;
  color: rgb(0 0 0 / 87%);
`;

export const MoreShopImage = styled.div`
  position: relative;
  text-align: center;
  margin-bottom: 8px;
  .image {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }

  span {
    position: unset !important;
    width: 100% !important;
    height: 74px !important;
  }
`;
export const MoreCategoryTitle = styled.h2`
  font-size: ${(props) =>
    props.ytVideo ? 'clamp(18px, 2vw, 19px)' : 'clamp(14px, 2vw, 19px)'};
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: hsl(0deg, 0%, 0%, 80%);
  text-align: ${(props) => (props.ytVideo ? 'left' : 'center')};
  padding: ${(props) => (props.browse ? '40px 0 18px' : '18px 0')};

  @media (max-width: 720px) {
    text-align: left;
    font-size: 16px;
    padding-left: 8px;
  }
`;
